const urlName = '/common-services/v1'
export default (API) => ({
	getShareConfig(params) {
		return API({
			params,
			method: 'get',
			url: `${urlName}/wx/getWeConfig`,
		})
  }
})
